import { snakeCase, mapKeys } from 'lodash';
import { GeneratedExpressionInterface, TransformationDefinition, TransformationInterface, WindowExtended } from '../types';

export const mapStateToWidgetParameter = (state: Record<string, unknown>) => mapKeys(state, (value, key) => snakeCase(key));

export const clearCloudinaryWidget = () => {
  const iFrame: HTMLElement = document.getElementsByTagName('iframe')[0];
  iFrame?.parentNode?.removeChild(iFrame);
};
export const showCloudinaryWidget = (params: Record<string, unknown>, window: WindowExtended, callbacks?: { insertHandler: unknown }) => {
  clearCloudinaryWidget();

  const widget = window.cloudinary?.openMediaLibrary(mapStateToWidgetParameter(params), callbacks);
  widget?.show();
  return widget;
};

export const generateSearchExpression = ({
  filterByAsset,
  filterByExpression,
  isSearchFilterByAsset,
  isSearchFilterByCustomExpression,
}: GeneratedExpressionInterface) => {
  let expr = '';
  let glue = '';
  if (filterByAsset?.value && isSearchFilterByAsset) {
    expr = `resource_type:${filterByAsset.value}`;
    glue = ' AND ';
  } else {
    expr = '';
  }
  if (filterByExpression && isSearchFilterByCustomExpression) {
    expr = `${expr}${glue}${filterByExpression}`;
  }
  return expr;
};

export const buildTransformations = (
  transformations?: TransformationInterface[],
  customTransformations?: string,
  areCustomTransformationsEnabled?: boolean
): TransformationDefinition[][] => {
  const defaultTransformations = transformations?.filter((transformation) => transformation.isSelected).map((item) => item.definition) ?? [];
  if (areCustomTransformationsEnabled) {
    const cTran =
      customTransformations
        ?.split(',')
        .map((item) => ({ raw_transformation: item.trim() }))
        .filter((item) => item.raw_transformation) ?? [];
    if (cTran.length) {
      defaultTransformations.push(...cTran);
    }
  }
  return [defaultTransformations];
};
